import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { onCLS, onLCP, onINP, onTTFB } from 'web-vitals';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Report Web Vitals (can send to analytics in production)
function reportWebVitals() {
  onCLS((m) => { if (process.env.NODE_ENV === 'development') console.log('[CLS]', m); });
  onLCP((m) => { if (process.env.NODE_ENV === 'development') console.log('[LCP]', m); });
  onINP((m) => { if (process.env.NODE_ENV === 'development') console.log('[INP]', m); });
  onTTFB((m) => { if (process.env.NODE_ENV === 'development') console.log('[TTFB]', m); });
}
reportWebVitals();
